<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <fuse-sidebar class="sidebar" name="order-main-sidebar" position="left" lockedOpen="gt-md">
        <sign-up-action-list-sidebar></sign-up-action-list-sidebar>
    </fuse-sidebar>

    <!-- CENTER -->
    <div class="center">
        <div class="content-card" style="overflow-y: scroll;">
            <!-- CONTENT -->
            <div id="ngx-datatable" class="page-layout simple fullwidth docs">
                <div class="content p-24">
                    <ngx-datatable
                        #table
                        class="material"
                        [rows]="rows"
                        [loadingIndicator]="loadingIndicator"
                        [columnMode]="'force'"
                        [headerHeight]="48"
                        [footerHeight]="56"
                        [rowHeight]="'auto'"
                        [scrollbarH]="true"
                        [reorderable]="reorderable"
                        [selectionType]="'checkbox'"
                        [externalPaging]="true"
                        [count]="page.totalElements"
                        [offset]="page.pageNumber"
                        [limit]="page.size"
                        (page)="setPage($event)">

                        <ngx-datatable-column [width]="48"
                                              [canAutoResize]="false"
                                              [sortable]="false">
                            <ng-template ngx-datatable-header-template let-value="value" let-allRowsSelected="allRowsSelected"
                                         let-selectFn="selectFn">
                            </ng-template>

                            <ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected"
                                         let-onCheckboxChangeFn="onCheckboxChangeFn">

                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'Name' | translate}}" prop="name">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.name}}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'Action key' | translate}}" prop="actionKey">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.actionKey}}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Is active' | translate}}" prop="isActive">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <span *ngIf="row.isActive">{{'Yes'|translate}}</span>
                                <span *ngIf="!row.isActive">{{'No'|translate}}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Created by' | translate}}" prop="createdBy">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <span *ngIf="row.createdBy">
                                    {{row.createdBy.firstName}} {{row.createdBy.lastName}} ({{row.createdBy.username}})
                                </span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Created at' | translate}}" prop="createdAt">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.createdAt | date:'dd.MM.yyyy H:mm:ss':'UTC'}}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Actions'|translate}}" sortable="true" prop="id">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <a *appIsGranted="['Marketing vouchers', 'UPDATE']" routerLink="/actions/edit/{{row.id}}">{{'Edit'|translate}}</a>
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>
            </div>
        </div>
    </div>
</div>